import { SearchOptionLinksObject } from 'components/SA/SearchProvider/types'
import { FilterPopularSearchesParams } from '../../types'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'
import {
  CATEGORY_VALUES_NAMES,
  ALLOWED_SUBJECT_VALUES,
  ALLOWED_STYLE_VALUES,
  ALL_MEDIUMS,
  ALL_MATERIALS,
  ALLOWED_PAINTINGS_MEDIUMS_VALUES,
  ALLOWED_PAINTINGS_MATERIALS_VALUES,
  ALLOWED_PHOTOGRAPHY_MEDIUMS_VALUES,
  ALLOWED_PHOTOGRAPHY_MATERIALS_VALUES,
  ALLOWED_DIGITAL_MEDIUMS_VALUES,
  ALLOWED_DIGITAL_MATERIALS_VALUES,
  ALLOWED_DRAWINGS_MEDIUMS_VALUES,
  ALLOWED_DRAWINGS_MATERIALS_VALUES,
  ALLOWED_MIXED_MEDIA_MEDIUMS_VALUES,
  ALLOWED_MIXED_MEDIA_MATERIALS_VALUES,
  ALLOWED_SCULPTURE_MEDIUMS_VALUES,
  ALLOWED_SCULPTURE_MATERIALS_VALUES,
  ALLOWED_COLLAGE_MEDIUMS_VALUES,
  ALLOWED_COLLAGE_MATERIALS_VALUES,
  ALLOWED_PRINTMAKING_MEDIUMS_VALUES,
  ALLOWED_PRINTMAKING_MATERIALS_VALUES,
  ALLOWED_INSTALLATION_MEDIUMS_VALUES,
  ALLOWED_INSTALLATION_MATERIALS_VALUES,
} from 'lib/constructor/constants/hardcodedSaatchiFilters'

const DEFAULT_POPULAR_SEARCHES = [
  {
    label: 'abstract',
    link: addStoreLocaleByCookie(`/all?query=${encodeURIComponent('abstract')}`),
  },
  {
    label: 'landscape',
    link: addStoreLocaleByCookie(`/all?query=${encodeURIComponent('landscape')}`),
  },
  {
    label: 'still life',
    link: addStoreLocaleByCookie(`/all?query=${encodeURIComponent('still-life')}`),
  },
  {
    label: 'pop art',
    link: addStoreLocaleByCookie(`/all?query=${encodeURIComponent('pop-art')}`),
  },
  {
    label: 'flowers',
    link: addStoreLocaleByCookie(`/all?query=${encodeURIComponent('flowers')}`),
  },
]

export const filterPopularSearches = ({
  selectedCategory,
  popularSearches,
  maxPopularSearches,
}: FilterPopularSearchesParams): ReadonlyArray<SearchOptionLinksObject> => {
  let hardcodedAllowedPopularSearches: Array<{ label: string; value: string }> = [
    ...ALLOWED_SUBJECT_VALUES,
    ...ALLOWED_STYLE_VALUES,
  ]

  switch (selectedCategory) {
    case CATEGORY_VALUES_NAMES.PAINTINGS:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALLOWED_PAINTINGS_MEDIUMS_VALUES,
        ...ALLOWED_PAINTINGS_MATERIALS_VALUES,
      ]
      break

    case CATEGORY_VALUES_NAMES.PHOTOGRAPHY:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALLOWED_PHOTOGRAPHY_MEDIUMS_VALUES,
        ...ALLOWED_PHOTOGRAPHY_MATERIALS_VALUES,
      ]
      break

    case CATEGORY_VALUES_NAMES.DIGITAL:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALLOWED_DIGITAL_MEDIUMS_VALUES,
        ...ALLOWED_DIGITAL_MATERIALS_VALUES,
      ]
      break

    case CATEGORY_VALUES_NAMES.DRAWINGS:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALLOWED_DRAWINGS_MEDIUMS_VALUES,
        ...ALLOWED_DRAWINGS_MATERIALS_VALUES,
      ]
      break

    case CATEGORY_VALUES_NAMES.MIXED_MEDIA:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALLOWED_MIXED_MEDIA_MEDIUMS_VALUES,
        ...ALLOWED_MIXED_MEDIA_MATERIALS_VALUES,
      ]
      break

    case CATEGORY_VALUES_NAMES.SCULPTURE:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALLOWED_SCULPTURE_MEDIUMS_VALUES,
        ...ALLOWED_SCULPTURE_MATERIALS_VALUES,
      ]
      break

    case CATEGORY_VALUES_NAMES.COLLAGE:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALLOWED_COLLAGE_MEDIUMS_VALUES,
        ...ALLOWED_COLLAGE_MATERIALS_VALUES,
      ]
      break

    case CATEGORY_VALUES_NAMES.PRINTMAKING:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALLOWED_PRINTMAKING_MEDIUMS_VALUES,
        ...ALLOWED_PRINTMAKING_MATERIALS_VALUES,
      ]
      break

    case CATEGORY_VALUES_NAMES.INSTALLATION:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALLOWED_INSTALLATION_MEDIUMS_VALUES,
        ...ALLOWED_INSTALLATION_MATERIALS_VALUES,
      ]
      break

    default:
      hardcodedAllowedPopularSearches = [
        ...hardcodedAllowedPopularSearches,
        ...ALL_MEDIUMS,
        ...ALL_MATERIALS,
      ]
  }

  const allowedPopularSearches = popularSearches.reduce((popularSearchOptions, { label, link }) => {
    if (popularSearchOptions.length >= maxPopularSearches) {
      return popularSearchOptions
    }

    const normalizedLabel = label?.toLowerCase() || ''
    const isValueAllowed = hardcodedAllowedPopularSearches.some(
      ({ value }) => value.toLowerCase() === normalizedLabel
    )

    if (isValueAllowed) {
      popularSearchOptions.push({
        label: normalizedLabel,
        link,
      })
    }

    return popularSearchOptions
  }, [] as Array<SearchOptionLinksObject>)

  const filterDuplicatesFromDefaultOptions = (
    allowedPopularSearchArray: ReadonlyArray<SearchOptionLinksObject>,
    defaultOptions: ReadonlyArray<SearchOptionLinksObject>
  ) => {
    const arrayOfOptions = new Set(
      allowedPopularSearchArray.map(({ label }) => label.toLowerCase())
    )
    return defaultOptions.filter(({ label }) => !arrayOfOptions.has(label.toLowerCase()))
  }

  const filteredDefaultOptions = filterDuplicatesFromDefaultOptions(
    allowedPopularSearches,
    DEFAULT_POPULAR_SEARCHES
  )

  const filteredPopularSearches = [...allowedPopularSearches, ...filteredDefaultOptions].slice(
    0,
    maxPopularSearches
  )
  return filteredPopularSearches
}
